export default class AuthenticationError extends Error {
	public name: AuthenticationErrorType;
	public message: string;

	constructor(name: AuthenticationErrorType, message: string) {
		super(message);
		this.name = name;
		this.message = message;
		Object.setPrototypeOf(this, AuthenticationError.prototype);
	}
}

export function isErrorOfType(errorType: AuthenticationErrorType, {name}: AuthenticationError): boolean {
	return name === errorType;
}

export function throwSessionTimedOutError() {
	throw new AuthenticationError(
		'SESSION_TIMED_OUT',
		'Session timed out.  Please login again');
}

export function throwIncorrectUsernameOrPasswordError() {
	throw new AuthenticationError(
		'INCORRECT_USERNAME_OR_PASSWORD',
		'Incorrect username and/or password.');
}

export function throwFailedToAuthenticateError(error: Error) {
	throw new AuthenticationError(
		'FAILED_TO_AUTHENTICATE',
		`Unable to authorize, ${error.message}`);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/errors/authentication.ts